import { render, staticRenderFns } from "./SponsoredRecommendationVideoHomeGlobal.vue?vue&type=template&id=00eb72d2&scoped=true"
import script from "./SponsoredRecommendationVideoHomeGlobal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationVideoHomeGlobal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationVideoHomeGlobal.vue?vue&type=style&index=0&id=00eb72d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00eb72d2",
  null
  
)

export default component.exports